import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ApplicationErrorComponent } from './core/application-error/application-error.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { ServiceWorkerModule } from '@angular/service-worker';

import { environment } from 'src/environments/environment';
import { ErrorInterceptorProvider } from './services/helpers/refresh-token.interceptor';
import { SessionService } from './services/session.service';


import { LoadingAnimationModule } from "./core/loading-animation/loading-animation.module";
//import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalBroadcastService, MsalGuard, MsalGuardConfiguration, MsalInterceptor, MsalInterceptorConfiguration, MsalModule, MsalRedirectComponent, MsalService } from "@azure/msal-angular";
//import { BrowserCacheLocation, InteractionType, IPublicClientApplication, LogLevel, PublicClientApplication } from "@azure/msal-browser";
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { FormTemplateComponent } from './core/templates/form-template/form-template.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ToastContainerComponent } from "./core/toast/toast-container.component";
import { ApiInterceptor, ApiInterceptorProvider } from './services/helpers/api.interceptor';
import { provideEnvironmentNgxMask } from 'ngx-mask';

// Register the locale data for Italy
registerLocaleData(localeIt, 'it');

/*export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}*/

/*export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.MicrosoftLoginData.clientId,
      authority: environment.MicrosoftLoginData.tenantId,
      redirectUri: 'https://192.168.114.49:4200',
      postLogoutRedirectUri: 'https://192.168.114.49:4200',
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage
    },
    system: {
      allowNativeBroker: false, // Disables WAM Broker
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set('https://login.microsoftonline.com', ['Scopes.Read']);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return { 
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [...'Scopes.Read']
    },
    loginFailedRoute: '/login'
  };
}*/

const isIE =
  window.navigator.userAgent.indexOf("MSIE ") > -1 ||
  window.navigator.userAgent.indexOf("Trident/") > -1;

@NgModule({
  declarations: [
    AppComponent,
    ApplicationErrorComponent,
    //ignoreHtmlSanifications,
  ],
  bootstrap: [AppComponent],
  imports: [
    MatSnackBarModule,
    BrowserModule,
    AppRoutingModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
        // enabled: !isDevMode(),
        enabled: environment.production,
        // Register the ServiceWorker as soon as the application is stable
        // or after 30 seconds (whichever comes first).
        //registrationStrategy: 'registerWhenStable:30000'
    }),
    LoadingAnimationModule,
    ToastContainerComponent
], 
    
  providers: [
    ApiInterceptorProvider, //maps api to error code and adds access token to headers
    ErrorInterceptorProvider, //checks if error is 401 and handles refresh token
    {
      provide: LOCALE_ID,
      deps: [SessionService],
      useFactory: (sessionService: SessionService) => sessionService.locale,
    },

    provideHttpClient(withInterceptorsFromDi()),
    /*{
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    MsalGuard,*/
    provideEnvironmentNgxMask(),
    provideAnimationsAsync(),
    /*{
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },*/
    /*{
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },*/
    /*{
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },*/
    /*MsalService,
    MsalBroadcastService,*/
  ],

})

export class AppModule {
  constructor() {
  }
}

